import { Box, Chip, Divider, List, Stack, Typography } from "@mui/material";

import { TeammateRow } from "./TeammateRow";
import { isInCallerBranch } from "./utils";

interface Props {
  label: string;
  teammates: CompanyMember[];
  callerBranchId: number | null;
  sharedRoleIds: ReadonlySet<number>;
  selectedRoleIds: ReadonlySet<number>;
  onToggle: (roleId: number) => void;
}

export function TeammateSection(props: Props) {
  const {
    label,
    teammates,
    callerBranchId,
    sharedRoleIds,
    selectedRoleIds,
    onToggle,
  } = props;

  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={1} pb={0.5}>
        <Typography
          variant="caption"
          fontWeight="fontWeightBold"
          color="text.secondary"
          textTransform="uppercase"
        >
          {label}
        </Typography>
        <Chip label={teammates.length} size="small" />
        <Divider sx={{ flex: 1 }} />
      </Stack>
      <List disablePadding>
        {teammates.map((teammate) => (
          <TeammateRow
            key={teammate.id}
            teammate={teammate}
            isInMyBranch={isInCallerBranch(teammate, callerBranchId)}
            isShared={sharedRoleIds.has(teammate.id)}
            isSelected={selectedRoleIds.has(teammate.id)}
            onToggle={onToggle}
          />
        ))}
      </List>
    </Box>
  );
}
